<template>
  <!-- eslint-disable -->
  <div>
    <b-overlay variant="white" :show="showLoading" spinner-variant="primary" blur="0" opacity=".75" rounded="sm">
      <b-card no-body class="mb-0">
        <b-table
          class="position-relative"
          :hover="true"
          :items="records"
          responsive
          :fields="fields"
          show-empty
          empty-text="No existen"
          @sort-changed="sortChanged"
        >
          <!-- Column: Actions -->
          <template #cell(actions)="data">
            <b-button
              size="sm"
              class=""
              @click.prevent="viewDetail(data.item)"
              v-b-tooltip.hover.top="'Ver'"
              variant="flat-info"
            >
              <feather-icon icon="EyeIcon" />
            </b-button>
            <b-button
              size="sm"
              class=""
              @click.prevent="edit(data.item)"
              v-b-tooltip.hover.top="'Editar'"
              variant="flat-secondary"
            >
              <feather-icon icon="Edit2Icon" />
            </b-button>
          </template>
        </b-table>
      </b-card>
    </b-overlay>
  </div>
</template>

<script>
/* eslint-disable */
import Vue from 'vue'
import { BootstrapVue, BootstrapVueIcons, VBTooltip } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import ExternalMovement from '@/services/ExternalMovement'
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
export default {
  directives: {
    'b-tooltip': VBTooltip,
    Ripple
  },
  data() {
    return {
      showLoading: false,
      records: [],
      fields: [
        { key: 'storeSelected.name', label: 'Tienda', sortable: false },
        { key: 'document_type', label: 'Tipo Documento', sortable: false },
        { key: 'documentDescription', label: 'Descripción', sortable: false },
        { key: 'actions', label: 'Acciones' }
      ],
      form: {
        id: null,
        store_type: '',
        name: '',
        address: ''
      },
      arrayFilters: [],
      currentPage: 1,
      entries: [10, 20, 50, 100],
      showEntrie: 20,
      totalElements: 0,
      id: 0,
      sort: 'id',
      order: 'desc'
    }
  },
  components: {},
  mounted() {
    this.getData()
  },
  methods: {
    edit(item) {
      console.log('item', item)
      this.$router.push('/inventario/salida/editar/' + item.id)
    },
    viewDetail(item) {
      this.$router.push('/inventario/salida/detalle/' + item.id)
    },
    async getData() {
      this.showLoading = true
      let offset = this.showEntrie * (this.currentPage - 1)
      // const url1 = `?limit=100&filter=pending`
      // const resp1 = await InternalMovement.getMovements(url1, this.$store)
      // console.log('resp1', resp1)
      const url = `?limit=${this.showEntrie}&offset=${offset}`
      const resp = await ExternalMovement.getMovements(url, this.$store)
      console.log('RESP EXTERNO', resp)
      if (resp) {
        this.records = resp.externalMovement
        // this.totalElements = resp.newResponse.length
      }
      this.showLoading = false
      console.log('this.records', this.records)
    },
    cambioPagina(e) {
      this.currentPage = e
    },
    changeSizePage() {},
    sortChanged(data) {
      this.sort = data.sortBy
      if (data.sortDesc) {
        this.order = 'desc'
      } else this.order = 'asc'
    }
  }
}
</script>

<style></style>
